import { trackError } from 'helpers/track_error';
import type { SurveyQuestionsKeys } from 'packages/signup/components/SurveyQuestions';

export default function trackQuestionAnswered(
  questionKey: SurveyQuestionsKeys,
  answer: string | boolean,
  surveySource?: string
) {
  try {
    GustoAnalytics.track({
      eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
      eventName: 'SurveySignupModalSurveyQuestionAnswered',
      data: {
        questionKey,
        answer,
        survey_source: surveySource,
      },
    });
  } catch (e) {
    trackError({
      error: new Error(
        `Error tracking SurveySignupModalSurveyQuestionAnswered for ${questionKey}:${answer}`
      ),
    });
  }
}
